import { render, staticRenderFns } from "./FoodLibrary.vue?vue&type=template&id=51dcf652&scoped=true&"
import script from "./FoodLibrary.vue?vue&type=script&lang=js&"
export * from "./FoodLibrary.vue?vue&type=script&lang=js&"
import style0 from "./FoodLibrary.vue?vue&type=style&index=0&id=51dcf652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcf652",
  null
  
)

export default component.exports